export const SET_INDUSTRIES = "SET_INDUSTRIES";